module.exports = __webpack_public_path__ + "img/33@2x.10f45d21.png";